export default __webpack_public_path__ + "static/media/youtube-fill.fe86a52e.svg";